var map = {
	"./acrobat.png": 8035,
	"./acrobatold1.png": 1786,
	"./alchemist.png": 9799,
	"./alchemistold1.png": 9611,
	"./alhadikhia.png": 8723,
	"./alsaahir.png": 3393,
	"./amnesiac.png": 5118,
	"./angel.png": 6474,
	"./ankotaladdin.png": 2543,
	"./ankotalice.png": 9306,
	"./ankotanansi.png": 4702,
	"./ankotanubis.png": 4816,
	"./ankotbabayaga.png": 7707,
	"./ankotbigbadwolf.png": 2132,
	"./ankotchesirecat.png": 7046,
	"./ankotclubs.png": 2868,
	"./ankotcustom_ankot.png": 2101,
	"./ankotdiamonds.png": 9170,
	"./ankotfrogprince.png": 8673,
	"./ankotgingerbreadman.png": 2993,
	"./ankotgoldspinner.png": 1249,
	"./ankothanselgretel.png": 9452,
	"./ankothearts.png": 4696,
	"./ankotifrit.png": 2646,
	"./ankotiwasamedi.png": 6073,
	"./ankotkitsune.png": 8090,
	"./ankotlittlematchgirl.png": 307,
	"./ankotmagicmirror.png": 95,
	"./ankotmaui.png": 7770,
	"./ankotmwindo.png": 5412,
	"./ankotnanahuatzin.png": 4648,
	"./ankotpiedpiper.png": 1871,
	"./ankotprincecharming.png": 4954,
	"./ankotqueenofhearts.png": 9756,
	"./ankotrakshasa.png": 339,
	"./ankotrapunzel.png": 57,
	"./ankotridinghood.png": 9007,
	"./ankotscheherazade.png": 2385,
	"./ankotshinigami.png": 4320,
	"./ankotshrek.png": 9882,
	"./ankotspades.png": 3100,
	"./ankotsunwukong.png": 7654,
	"./ankotyurlunggur.png": 2793,
	"./apprentice.png": 819,
	"./artist.png": 6835,
	"./assassin.png": 3169,
	"./atheist.png": 946,
	"./balloonist.png": 5926,
	"./balloonistold1.png": 1155,
	"./banshee.png": 8063,
	"./banxian.png": 2936,
	"./baojun.png": 3278,
	"./barber.png": 8069,
	"./barista.png": 2437,
	"./baron.png": 8230,
	"./beggar.png": 1082,
	"./bianlianshi.png": 4447,
	"./bigwig.png": 152,
	"./bingbi.png": 3914,
	"./bishop.png": 5343,
	"./boffin.png": 8775,
	"./bonecollector.png": 1594,
	"./boomdandy.png": 3682,
	"./bootlegger.png": 1954,
	"./bountyhunter.png": 7479,
	"./buddhist.png": 1990,
	"./bureaucrat.png": 367,
	"./butcher.png": 177,
	"./butler.png": 4697,
	"./cacklejack.png": 8985,
	"./cannibal.png": 6214,
	"./cerenovus.png": 7637,
	"./chambermaid.png": 1146,
	"./chef.png": 1248,
	"./choirboy.png": 5081,
	"./chongfei.png": 5671,
	"./clockmaker.png": 5102,
	"./courtier.png": 759,
	"./cultleader.png": 2763,
	"./custom.png": 7037,
	"./dagengren.png": 4783,
	"./damsel.png": 5533,
	"./daoke.png": 1525,
	"./daoshi.png": 3652,
	"./demons.png": 9300,
	"./deusexfiasco.png": 8141,
	"./deusexfiascoold2.png": 6907,
	"./deviant.png": 1683,
	"./devilsadvocate.png": 5549,
	"./dianxiaoer.png": 2891,
	"./dianyuzhang.png": 7420,
	"./diaomin.png": 530,
	"./djinn.png": 393,
	"./doomsayer.png": 5142,
	"./dreamer.png": 1610,
	"./drunk.png": 3669,
	"./duchess.png": 2491,
	"./duck.png": 4395,
	"./empath.png": 5695,
	"./engineer.png": 7571,
	"./evil.png": 1836,
	"./eviltwin.png": 7664,
	"./exorcist.png": 5858,
	"./fabled.png": 5025,
	"./fableds.png": 2410,
	"./fanggu.png": 1833,
	"./fangshi.png": 442,
	"./farmer.png": 4390,
	"./fearmonger.png": 5297,
	"./fengshuishi.png": 6540,
	"./ferryman.png": 762,
	"./fibbin.png": 9332,
	"./fiddler.png": 5076,
	"./fisherman.png": 2776,
	"./flowergirl.png": 6053,
	"./fool.png": 647,
	"./fortuneteller.png": 9336,
	"./gambler.png": 4306,
	"./gangster.png": 782,
	"./ganshiren.png": 169,
	"./gardener.png": 6871,
	"./geling.png": 8533,
	"./general.png": 2990,
	"./gnome.png": 2962,
	"./goblin.png": 1730,
	"./godfather.png": 8536,
	"./godofug.png": 7537,
	"./golem.png": 7274,
	"./good.png": 6832,
	"./goon.png": 1273,
	"./gossip.png": 5965,
	"./grandmother.png": 4950,
	"./gudiao.png": 8115,
	"./guhuoniao.png": 1957,
	"./gunslinger.png": 7768,
	"./harlot.png": 6226,
	"./harpy.png": 3865,
	"./hatter.png": 3490,
	"./hellslibrarian.png": 5477,
	"./heretic.png": 6314,
	"./hermit.png": 6004,
	"./heshang.png": 3786,
	"./highpriestess.png": 6251,
	"./hindu.png": 382,
	"./huapi.png": 9414,
	"./humeiniang.png": 9325,
	"./hundun.png": 8420,
	"./huntsman.png": 7893,
	"./imp.png": 2830,
	"./innkeeper.png": 6580,
	"./investigator.png": 9813,
	"./jianning.png": 4481,
	"./jiaohuazi.png": 5035,
	"./jinweijun.png": 1991,
	"./jinyiwei.png": 9235,
	"./jiubao.png": 6452,
	"./judge.png": 6306,
	"./juggler.png": 8785,
	"./kazali.png": 1465,
	"./king.png": 6865,
	"./klutz.png": 1938,
	"./knaves.png": 427,
	"./knight.png": 3395,
	"./langzhong.png": 2245,
	"./legion.png": 2339,
	"./leviathan.png": 3245,
	"./librarian.png": 651,
	"./lilmonsta.png": 4090,
	"./lilmonstaold1.png": 4514,
	"./limao.png": 4527,
	"./lleech.png": 1424,
	"./lordoftyphon.png": 6262,
	"./loric.png": 7766,
	"./lunatic.png": 2561,
	"./lycanthrope.png": 8746,
	"./lycanthropeold1.png": 8823,
	"./magician.png": 4214,
	"./marionette.png": 712,
	"./mastermind.png": 7100,
	"./mathematician.png": 3850,
	"./matron.png": 8054,
	"./mayor.png": 8827,
	"./mengpo.png": 1239,
	"./mephit.png": 3304,
	"./mezepheles.png": 295,
	"./minion.png": 847,
	"./minions.png": 3272,
	"./minstrel.png": 3415,
	"./monk.png": 4409,
	"./moonchild.png": 8749,
	"./mutant.png": 4473,
	"./niangjiushi.png": 7662,
	"./nichen.png": 4845,
	"./nightwatchman.png": 2666,
	"./noble.png": 1004,
	"./nodashii.png": 2458,
	"./ogre.png": 2306,
	"./ojo.png": 3073,
	"./oracle.png": 9624,
	"./organgrinder.png": 5705,
	"./orthodontist.png": 1214,
	"./outsider.png": 8814,
	"./outsiders.png": 4719,
	"./pacifist.png": 5873,
	"./philosopher.png": 3300,
	"./pithag.png": 1282,
	"./pixie.png": 8637,
	"./plaguedoctor.png": 5985,
	"./plus.png": 4511,
	"./po.png": 5631,
	"./poisoner.png": 6763,
	"./politician.png": 4265,
	"./pope.png": 2380,
	"./poppygrower.png": 8828,
	"./preacher.png": 3213,
	"./princess.png": 8705,
	"./professor.png": 889,
	"./psychopath.png": 7826,
	"./pukka.png": 4486,
	"./puzzlemaster.png": 7002,
	"./qianke.png": 106,
	"./qilin.png": 2247,
	"./qintianjian.png": 1400,
	"./qiongqi.png": 4275,
	"./ranfangfangzhu.png": 7514,
	"./ravenkeeper.png": 6965,
	"./recluse.png": 3035,
	"./revolutionary.png": 9038,
	"./riot.png": 8118,
	"./rulianshi.png": 3191,
	"./sage.png": 6544,
	"./sailor.png": 8984,
	"./saint.png": 4811,
	"./savant.png": 7884,
	"./scapegoat.png": 6701,
	"./scarletwoman.png": 3957,
	"./seamstress.png": 4201,
	"./sentinel.png": 4213,
	"./shabaloth.png": 2034,
	"./shaxing.png": 5437,
	"./shelingchengzhi.png": 7097,
	"./shiguan.png": 7641,
	"./shijie.png": 3663,
	"./shugenja.png": 922,
	"./shusheng.png": 7989,
	"./shutong.png": 5075,
	"./slayer.png": 8081,
	"./snakecharmer.png": 9900,
	"./snitch.png": 7988,
	"./soldier.png": 2231,
	"./spiritofivory.png": 3379,
	"./spy.png": 4013,
	"./steward.png": 6050,
	"./stormcatcher.png": 3877,
	"./summoner.png": 817,
	"./sweetheart.png": 6356,
	"./syyl.png": 6807,
	"./taotie.png": 6019,
	"./taowu.png": 893,
	"./tealady.png": 3009,
	"./thief.png": 7112,
	"./tinker.png": 5380,
	"./tixingguan.png": 6304,
	"./tor.png": 2928,
	"./towncrier.png": 4055,
	"./townsfolks.png": 8356,
	"./toymaker.png": 3163,
	"./travelers.png": 9606,
	"./undertaker.png": 5466,
	"./ventriloquist.png": 155,
	"./vigormortis.png": 4969,
	"./villageidiot.png": 4883,
	"./virgin.png": 6954,
	"./vizier.png": 5485,
	"./vortox.png": 6142,
	"./voudon.png": 3445,
	"./washerwoman.png": 245,
	"./widow.png": 3729,
	"./witch.png": 6909,
	"./wizard.png": 3264,
	"./wraith.png": 8343,
	"./wudaozhe.png": 3040,
	"./x.png": 1139,
	"./xaan.png": 3505,
	"./xionghaizi.png": 4167,
	"./xizi.png": 124,
	"./xuncha.png": 6843,
	"./yaggababble.png": 4520,
	"./yangguren.png": 3364,
	"./yanluo.png": 7210,
	"./yanshi.png": 8199,
	"./yinluren.png": 9192,
	"./yinyangshi.png": 1499,
	"./yishi.png": 6932,
	"./yongjiang.png": 1706,
	"./zealot.png": 6722,
	"./zenomancer.png": 4725,
	"./zhen.png": 755,
	"./zhifu.png": 6375,
	"./zombuul.png": 8899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;